import 'regenerator-runtime/runtime';
// Note: core-js/stable is needed here to enable the browser warning UI in older browsers
import 'core-js/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import LaunchDarkly from 'src/shared/components/LaunchDarkly';
import TelehealthWorkflow from 'src/workflow/TelehealthWorkflow';
import { getAthenaContextId } from 'src/components/utils/Helper';
import { initApp } from './init';

const contextId = getAthenaContextId();
const ldClientSideId = process.env.LAUNCH_DARKLY_CLIENT_ID as string;

// We can conserve unique user counts in LD (cMAU) by employing the same user key that was used by the CDN to pick the stack.
const ldUserKey =
  document.cookie
    ?.split('; ')
    ?.find((cookie) => cookie.startsWith('X-athena-px-ldu'))
    ?.split('=')[1] ?? 'th';

initApp(ldUserKey);

const TelehealthWorkflowLDWrapper = () => (
  <LaunchDarkly anonymous={true} ldContext={{ contextId }} ldUserKey={ldUserKey} clientSideId={ldClientSideId}>
    <TelehealthWorkflow />
  </LaunchDarkly>
);

const root = createRoot(document.querySelector('#telehealth-workflow') as Element);
root.render(<TelehealthWorkflowLDWrapper />);
